import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import AttachmentCard from "../../../../../../../../ui/AttachmentCard";

const useStyles = makeStyles(() => ({
    container: {
        display: "flex",
        "& > div": {
            marginRight: 15
        }
    }
}));

const DocumentList = ({ files, deleteAttach }) => {
    const classes = useStyles();

    return (
        <div className={classes.container}>
            {files.map(file => (
              <AttachmentCard key={`doc_key_${file.id}`}
                              download={true}
                              showmenu={true}
                              fileLink={file.id}
                              fileName={file.fileName}
                              fileSize={file.fileSize}
                              mimeType={file.mimeType}
                              removeDocument={() => deleteAttach(file.id)}/>
            ))}
        </div>
    );
};

export default DocumentList;
